import { computed, inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { VideoSettingsDto } from '@client/shared/models/video-settings.dto';
import { VideoSettingsApiService } from '@client/shared/services/api/video-settings-api.service';

@Injectable({ providedIn: 'root' })
export class ClientVideoStateService {

  readonly #videoSettingsApiService = inject(VideoSettingsApiService);

  readonly isVideoMode = signal(false);

  readonly therapyPlanPlayingId = signal<null | string>(null);
  readonly exercisePlayingId = signal<null | string>(null);

  readonly videoSettings: WritableSignal<VideoSettingsDto | null> = signal(null);
  readonly isExerciseExplanationAlwaysSkipped = computed(() => this.videoSettings()?.isSkippingVideoExplanationEnabled ?? false);

  setIsVideoMode(isVideoMode: boolean) {
    this.isVideoMode.set(isVideoMode);
  }

  getIsVideoMode(): Signal<boolean> {
    return this.isVideoMode.asReadonly();
  }

  loadVideoSettings(): void {
    this.#videoSettingsApiService
      .getVideoSettings()
      .subscribe((settings: VideoSettingsDto) => this.videoSettings.set(settings));
  }

  setTherapyPlanPlayingId(therapyPlanId: string | null): void {
    this.therapyPlanPlayingId.set(therapyPlanId);
  }

  setExercisePlayingId(exerciseId: string | null): void {
    this.exercisePlayingId.set(exerciseId);
  }
}
